import React from 'react';
import DataList from '../DataList';
import { getFaculties, deleteFaculty, bulkDeleteFaculties, bulkUploadFaculties } from '../../api/data';

const FacultiesList: React.FC = () => {
  const config = {
    title: 'Faculties',
    singularName: 'faculty',
    columns: [
      { key: 'faculty_code', label: 'Code' },
      { key: 'name_ar', label: 'Arabic Name' },
      { key: 'name_en', label: 'English Name' },
      { key: 'program_count', label: 'Programs' },
    ],
    fetchData: getFaculties,
    deleteItem: deleteFaculty,
    bulkDelete: bulkDeleteFaculties,
    bulkUpload: bulkUploadFaculties,
  };

  return <DataList config={config} />;
};

export default FacultiesList;
